// 预约挂号——微信，结束
// 预约挂号——微信，主流程
const wxMainRoutes = Array.from({ length: 17 }, (_, i) => ({
  path: `register/wx/index${i + 1}`,
  name: `registerWxIndex${i + 1}`,
  component: () => import(`@/views/health/register/wx/index${i + 1}.vue`),
}));
// 预约挂号——微信，分支1
const wxBranch1Routes = Array.from({ length: 8 }, (_, i) => ({
  path: `register/wx/branch1/index${i + 1}`,
  name: `registerWxBranch1Index${i + 1}`,
  component: () =>
    import(`@/views/health/register/wx/branch1/index${i + 1}.vue`),
}));
// 预约挂号——微信，分支2
const wxBranch2Routes = Array.from({ length: 5 }, (_, i) => ({
  path: `register/wx/branch2/index${i + 1}`,
  name: `registerWxBranch2Index${i + 1}`,
  component: () =>
    import(`@/views/health/register/wx/branch2/index${i + 1}.vue`),
}));

// 预约挂号——支付宝，结束

// 预约挂号——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 16 }, (_, i) => ({
  path: `register/zfb/index${i + 1}`,
  name: `registerZfbIndex${i + 1}`,
  component: () => import(`@/views/health/register/zfb/index${i + 1}.vue`),
}));
// 预约挂号——支付宝，分支1
const zfbBranch1Routes = Array.from({ length: 6 }, (_, i) => ({
  path: `register/zfb/branch1/index${i + 1}`,
  name: `registerZfbBranch1Index${i + 1}`,
  component: () =>
    import(`@/views/health/register/zfb/branch1/index${i + 1}.vue`),
}));
// 预约挂号——支付宝，分支2
const zfbBranch2Routes = Array.from({ length: 5 }, (_, i) => ({
  path: `register/zfb/branch2/index${i + 1}`,
  name: `registerZfbBranch2Index${i + 1}`,
  component: () =>
    import(`@/views/health/register/zfb/branch2/index${i + 1}.vue`),
}));

export default {
  path: "/health",
  component: { render: (c) => c("router-view") },
  children: [
    // 预约挂号——微信，主流程
    ...wxMainRoutes,
 

    // 预约挂号——微信，分支1
    ...wxBranch1Routes,

    // 预约挂号——微信，分支2
    ...wxBranch2Routes,

    // 预约挂号——支付宝，主流程
    ...zfbMainRoutes,

    // 预约挂号——支付宝，分支1
    ...zfbBranch1Routes,

    // 预约挂号——支付宝，分支2
    ...zfbBranch2Routes,
  ],
};
